import { NgModule } from '@angular/core';
import { ContentModule } from './components/content/content.module';
import { HeroModule } from './components/hero/hero.module';
import { PageInfoModule } from './components/page-info/page-info.module';
import { CardModule } from './components/card/card.module';
import { CommonModule } from '@angular/common';
import { SectionHeaderModule } from './components/section-header/section-header.module';
import { SectionImageContentModule } from './components/section-image-content/section-image-content.module';
import { InViewportModule } from 'ng-in-viewport';
import { HtmlPipe, ReplacePipe, SafePipe } from './safe.pipe';
import { EventCardModule } from './components/card/event/event.module';
import { MerchantCardModule } from './components/card/merchant/merchant.module';
import { StoreCardModule } from './components/card/store/store.module';
import { AttractionCardModule } from './components/card/attraction/attraction.module';
import { BuzzCardModule } from './components/card/buzz/buzz.module';
import { NgxMaskModule } from 'ngx-mask';
import { AutofocusDirective } from './components/autofocus/autofocus.directive';
import { SectionFooterModule } from './components/section-footer/section-footer.module';
import { FormsModule } from '@angular/forms';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import {CmsContentComponent} from './components/cms-content/cms-content';
import {PipesModule} from './pipes.module';
import {HeroVideoModule} from './components/hero-video/hero-video.module';

@NgModule({
  declarations: [
    CmsContentComponent
  ],
  imports: [
    CommonModule,
    ButtonsModule,
    FormsModule,
    CardModule,
    ContentModule,
    HeroModule,
    HeroVideoModule,
    PageInfoModule,
    SectionHeaderModule,
    SectionFooterModule,
    SectionImageContentModule,
    InViewportModule,
    EventCardModule,
    MerchantCardModule,
    StoreCardModule,
    AttractionCardModule,
    BuzzCardModule,
    NgxMaskModule.forRoot(),
    PipesModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ButtonsModule,
    CardModule,
    ContentModule,
    HeroModule,
    HeroVideoModule,
    PageInfoModule,
    SectionHeaderModule,
    SectionFooterModule,
    SectionImageContentModule,
    InViewportModule,
    SafePipe,
    HtmlPipe,
    CmsContentComponent,
    ReplacePipe,
    EventCardModule,
    MerchantCardModule,
    StoreCardModule,
    AttractionCardModule,
    BuzzCardModule
  ]
})
export class AppCommonModule { }
